var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M21.55.773a2.576 2.576 0 013.2-.386L25 .56l.262.238.207.242c.71.94.706 2.242-.028 3.21l-.209.24-15.84 15.983 39.683.001a2.925 2.925 0 110 5.85H9.39L25.233 42.31c.818.825.99 2.05.476 3.061l-.092.166-.172.254-.236.264-.24.21a2.582 2.582 0 01-3.152-.004l-.266-.235C8.113 32.63 1.343 25.9 1.239 25.834l-.232-.162-.265-.24-.207-.243c-.394-.521-.576-1.166-.52-1.7a2.658 2.658 0 01.548-1.915l.233-.26.24-.21c.184-.141 7.023-6.918 20.515-20.33z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 .6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "matrix(-1 0 0 1 52 0)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.2-7.8h62.4v62.4H-5.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.57b0c26860533526aab0429f0acb1dd1.svg";
export { ForwardRef as ReactComponent };